import { updateInternalSearchSessionStorage } from "components/page-components/Internal-Search/utils"
import { useState } from "react"

export const useInternalSearchState = ({ all_types }) => {
  const initial_search_state = {
    distinct: true,
    refinementList: {
      scope: ["website", "notice"],
      type: [...all_types],
      tags: [],
    },
    query: "",
  }

  const [searchState, setSearchState] = useState(initial_search_state)

  const [emptyState, setEmptyState] = useState(true)

  const onSearchStateChange = (updatedSearchState) => {
    setEmptyState(false)
    setSearchState(updatedSearchState)
    updateInternalSearchSessionStorage({
      last_search_state: updatedSearchState,
    })
  }

  return { emptyState, searchState, setSearchState, onSearchStateChange }
}
